// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__oLvJW","header":"MergedInvoice_header__2zQ8X"};